import React from 'react';
import { bodiedSyncBlock, syncBlock } from '@atlaskit/adf-schema';
import { blockTypeMessages } from '@atlaskit/editor-common/messages';
import { IconSyncBlock } from '@atlaskit/editor-common/quick-insert';
import { SyncBlockStoreManager } from '@atlaskit/editor-synced-block-provider';
import { flushBodiedSyncBlocks as _flushBodiedSyncBlocks } from './editor-actions';
import { createSyncedBlock } from './editor-commands';
import { createPlugin } from './pm-plugins/main';
import { getBlockMenuComponents } from './ui/block-menu-components';
import { DeleteConfirmationModal } from './ui/DeleteConfirmationModal';
import { getToolbarConfig } from './ui/floating-toolbar';
import { SyncBlockRefresher } from './ui/SyncBlockRefresher';
export var syncedBlockPlugin = function syncedBlockPlugin(_ref) {
  var _api$blockMenu;
  var config = _ref.config,
    api = _ref.api;
  var syncBlockStore = new SyncBlockStoreManager(config === null || config === void 0 ? void 0 : config.dataProvider);
  api === null || api === void 0 || (_api$blockMenu = api.blockMenu) === null || _api$blockMenu === void 0 || _api$blockMenu.actions.registerBlockMenuComponents(getBlockMenuComponents(api));
  return {
    name: 'syncedBlock',
    nodes: function nodes() {
      return [{
        name: 'syncBlock',
        node: syncBlock
      }, {
        name: 'bodiedSyncBlock',
        node: bodiedSyncBlock
      }];
    },
    pmPlugins: function pmPlugins() {
      return [{
        name: 'syncedBlockPlugin',
        plugin: function plugin(params) {
          return createPlugin(config, params, syncBlockStore, api);
        }
      }];
    },
    commands: {
      insertSyncedBlock: function insertSyncedBlock() {
        return function (_ref2) {
          var tr = _ref2.tr;
          return createSyncedBlock({
            tr: tr,
            syncBlockStore: syncBlockStore
          }) || null;
        };
      }
    },
    actions: {
      flushBodiedSyncBlocks: function flushBodiedSyncBlocks() {
        return _flushBodiedSyncBlocks(syncBlockStore);
      }
    },
    pluginsOptions: {
      quickInsert: function quickInsert(_ref3) {
        var formatMessage = _ref3.formatMessage;
        return [{
          id: 'syncBlock',
          title: formatMessage(blockTypeMessages.syncedBlock),
          description: formatMessage(blockTypeMessages.syncedBlockDescription),
          priority: 800,
          keywords: ['synced', 'block', 'synced-block', 'sync', 'sync-block', 'auto', 'update', 'excerpt', 'connect'],
          keyshortcut: '',
          icon: function icon() {
            return /*#__PURE__*/React.createElement(IconSyncBlock, {
              label: formatMessage(blockTypeMessages.syncedBlock)
            });
          },
          action: function action(insert, state) {
            return createSyncedBlock({
              tr: state.tr,
              syncBlockStore: syncBlockStore,
              typeAheadInsert: insert
            });
          }
        }];
      },
      floatingToolbar: function floatingToolbar(state, intl, providerFactory) {
        return getToolbarConfig(state, intl, config, providerFactory, api, syncBlockStore);
      }
    },
    contentComponent: function contentComponent() {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SyncBlockRefresher, {
        syncBlockStoreManager: syncBlockStore
      }), /*#__PURE__*/React.createElement(DeleteConfirmationModal, {
        syncBlockStoreManager: syncBlockStore
      }));
    }
  };
};